import React from 'react'
import './AddHeader.css'
import { Breadcrumb } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import CustomButton from '../CustomButton/CustomButton'
function AddHeader({ title, handleSubmit, text }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='py-3 px-4  add_header_container'>
      <div>
        <h1 className='title'>{title}</h1>
        <Breadcrumb>
          <Breadcrumb.Item href="/dashboard/Dashboard">{currentLocal.home.dashboard}</Breadcrumb.Item>

          <Breadcrumb.Item active>{title}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      {text&&
      <div className='btn_container'>
        <CustomButton
          onPress={handleSubmit}
          text={text}

        />
      </div>
}
    </div>
  )
}

export default AddHeader
